// Formas de pago que acepta la tienda en línea (negocios.tienda_pago, sql/114).
// La clienta elige una al hacer su pedido; el cobro se coordina por WhatsApp.

export const METODOS_PAGO = [
  { valor: 'transferencia', nombre: 'Transferencia o depósito', icono: '🏦' },
  { valor: 'efectivo', nombre: 'Efectivo al recibir', icono: '💵' },
  { valor: 'link', nombre: 'Link de pago (tarjeta de crédito o débito)', icono: '🔗' },
  { valor: 'tarjeta', nombre: 'Tarjeta POS (solo en tienda física)', icono: '💳' },
  { valor: 'billetera', nombre: 'Billetera móvil', icono: '📱' },
];

// Si la tienda todavía no eligió, se ofrecen las dos más comunes.
export const PAGO_DEFECTO = ['transferencia', 'efectivo'];

export function normalizarPago(p) {
  const o = p && typeof p === 'object' && !Array.isArray(p) ? p : {};
  const validos = METODOS_PAGO.map((m) => m.valor);
  const lista = Array.isArray(o.metodos) ? validos.filter((v) => o.metodos.includes(v)) : PAGO_DEFECTO;
  return { metodos: lista };
}

export const metodoPago = (valor) => METODOS_PAGO.find((m) => m.valor === valor) || null;
export const textoPago = (valor) => { const m = metodoPago(valor); return m ? `${m.icono} ${m.nombre}` : ''; };
